module.exports = __webpack_public_path__ + "static/media/img-function-offer.18693f58.png";